import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { lnbActiveAtom } from '.';
import type { GnbItem } from '../gnb-menu';
import NavLink from './NavLink';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const Container = styled.nav`
display: flex;
width: 100%;
height: 64px;
border-top: 1px solid ${colors.brightGrey3};
grid-column: 1 / 3;
overflow-x: auto;

@media (max-width: ${breakpointMedium}) {
  height: 48px;
}
`;

const Item = styled.span<{ active: boolean }>`
display: grid;
color: ${({ active }) => active ? colors.dark : colors.brightGrey};
white-space: nowrap;

& > a {
  display: grid;
  padding: 0 16px;
  place-items: center;
}
`;

type LnbProps = {
  menu: GnbItem,
};

const Lnb = ({ menu }: LnbProps) => {
  const active = useAtomValue(lnbActiveAtom);
  const router = useRouter();

  const route = useMemo(
    () => router.pathname,
    [router.pathname],
  );

  const valid = useMemo(() => (
    active === null && menu.children?.some(({ path }) => path === route) ||
    active === menu
  ), [active, menu, route]);

  if (!valid || !menu.children)
    return null;

  return (
    <Container>
      {menu.children.map((item) => (
        <Item
          key={item.title}
          active={route === item.path}
        >
          <NavLink item={item}>{item.title}</NavLink>
        </Item>
      ))}
    </Container>
  );
};

export default Lnb;
